import { getAxiosInstance } from '../../axios/axiosInstance';

const isUserInWaitlist = async (userId) => {
    try {
        const axiosInstance = getAxiosInstance();
        const response = await axiosInstance.get(`/waitlist/${userId}`);

        if(response.status !== 200) {
            throw new Error('Failed to check if user is in waitlist');
        }

        return response;

    } catch (error) {
        throw error;
    }
};


const addUserToWaitlist = async (data) => {
    try {
        const axiosInstance = getAxiosInstance();

        const response = await axiosInstance.post('/waitlist', data);

        if(response.status !== 200) {
            throw new Error('Erreur lors de l\'ajout à la liste d\'attente');
        }

        setIsUserInWaitlistInLocalStorage();
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
};


const getIsUserInWaitlistInLocalStorage = () => {
    try {
        const isInWaitlist = localStorage.getItem('isInWaitlist');
        return isInWaitlist === 'true';
    } catch {
        return false;
    }
}


const setIsUserInWaitlistInLocalStorage = () => {
    try {
        localStorage.setItem('isInWaitlist', 'true');
    } catch (error) {
        console.error('Erreur lors de la sauvegarde dans localStorage:', error);
    }
}

const shouldShowWaitlistBottomSheet = async (user) => {
    if (user?._id) {
        try {
            await isUserInWaitlist(user._id);
            return false;
        } catch (error) {
            return true;
        }
    }

    return !getIsUserInWaitlistInLocalStorage();
}

const prodBetaUserStore = {
    matchMedrevilleId : "65e6388eb6667e3400b5b8d8",
    matchHautBornesId : "67eab978a561e70773c59912",
}


export {
    isUserInWaitlist,
    addUserToWaitlist,
    getIsUserInWaitlistInLocalStorage,
    setIsUserInWaitlistInLocalStorage,
    shouldShowWaitlistBottomSheet,
    prodBetaUserStore
};
